/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Expanded/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Expanded({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/Calendar/Content/Content/Topbar/LowerSection/AppointmentCount/Expanded"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let calendarAppointmentCountValueData = fromData.useDataFormat({ viewPath,
context: 'calendar',
path: 'appointment_count',
format: fromHelpers.formatCount,
})
let calendarAppointmentCountValueData1 = fromData.useDataFormat({ viewPath,
context: 'calendar',
path: 'appointment_count',
format: fromHelpers.formatText,
})
  return (<React.Fragment
>
<div
  data-testid="Expanded.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-Z2dncGL': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="calendar.appointment_count"
 format="helpers.js formatCount"
 text={calendarAppointmentCountValueData}
 size="small"
 weight="medium"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="calendar.appointment_count"
 format="helpers.js formatText"
 text={calendarAppointmentCountValueData1}
 size="small"
 weight="regular"
/>
</div>
{children}
</React.Fragment>)
}